import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import VideoCounseling from './pages/video-counseling';
import ChatInterface from './pages/chat-interface';
import InstituteDashboard from './pages/institute-dashboard';
import StudentDashboard from './pages/student-dashboard';
import StudentRegistration from './pages/student-registration';
import InstituteLogin from './pages/institute-login';
import VirtualBooth from './pages/virtual-booth';
import ExhibitionHall from './pages/exhibition-hall';
import CampusTour360 from './pages/360-campus-tour';
import AuthCallback from './pages/auth-callback';
import ExploreInstitutions from './pages/explore-institutions';
import InstituteVideoSession from './pages/institute-video-session';
import StudyExpoHomePage from './pages/study-expo-home-page';
import AuditoriumWebinarHub from './pages/auditorium-webinar-hub';
import AdminLogin from './pages/admin-login';
import PendingApproval from './pages/pending-approval';
import GroupCounselingSessions from './pages/group-counseling-sessions';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public routes — accessible without login */}
            <Route path="/" element={<StudyExpoHomePage />} />
            <Route path="/study-expo-home-page" element={<StudyExpoHomePage />} />
            <Route path="/student-registration" element={<StudentRegistration />} />
            <Route path="/institute-login" element={<InstituteLogin />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/pending-approval" element={<PendingApproval />} />

            {/* Protected routes — require authentication */}
            <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/video-counseling" element={<ProtectedRoute><VideoCounseling /></ProtectedRoute>} />
            <Route path="/chat-interface" element={<ProtectedRoute><ChatInterface /></ProtectedRoute>} />
            <Route path="/conversations/new" element={<ProtectedRoute><ExploreInstitutions /></ProtectedRoute>} />
            <Route path="/explore-institutions" element={<ProtectedRoute><ExploreInstitutions /></ProtectedRoute>} />
            <Route path="/institute-dashboard" element={<ProtectedRoute><InstituteDashboard /></ProtectedRoute>} />
            <Route path="/student-dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
            <Route path="/virtual-booth/:id" element={<ProtectedRoute><VirtualBooth /></ProtectedRoute>} />
            <Route path="/exhibition-hall" element={<ExhibitionHall />} />
            <Route path="/360-campus-tour/:id" element={<ProtectedRoute><CampusTour360 /></ProtectedRoute>} />
            <Route path="/auditorium-webinar-hub" element={<ProtectedRoute><AuditoriumWebinarHub /></ProtectedRoute>} />
            <Route path="/institute-video-session" element={<ProtectedRoute><InstituteVideoSession /></ProtectedRoute>} />
            <Route path="/group-counseling-sessions" element={<ProtectedRoute><GroupCounselingSessions /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
